import { cloneDeep, get } from "lodash";
import { FormFields } from ".";
import { ConditionalFormRenderer } from "./ConditionalFormRenderer";
import { GroupRenderer } from "./GroupRenderer";

export const dynamicFormFieldValidator = (
  formFields: FormFields,
  values: { [key: string]: any }
) => {
  let fieldsNames = {};
  if (!formFields) return fieldsNames;
  formFields.forEach((row) => {
    row.forEach((_item) => {
      let props: any = {};
      const item = cloneDeep(_item);
      if (typeof item.props === "function") {
        item.props = item.props(null);
      }
      if (item.name) {
        if (item.component === GroupRenderer) {
          if (Array.isArray(values[item.name])) {
            props = [];
            values[item.name].forEach((itemValue: any) => {
              if (item.props)
                (props as any[]).push(
                  dynamicFormFieldValidator(item.props["fields"], itemValue)
                );
            });
          }
        }

        if (item.props && item.props["type"] === "currency") {
          props.parser = (v: string): number | undefined => {
            if (v) return parseFloat(v);
            return undefined;
          };
        }

        fieldsNames[item.name] = props;
      } else {
        if (item.component === ConditionalFormRenderer) {
          if (item.props)
            props = dynamicFormFieldValidator(
              item.props["conditionalFields"][
                get(values, item.props["conditionFieldName"])
              ],
              values
            );
          fieldsNames = {
            ...fieldsNames,
            ...props,
          };
        }
      }
    });
  });
  return fieldsNames;
};

export const objParser = (obj: any, schema: any) => {
  Object.keys(obj).forEach((key) => {
    if (!schema[key]) delete obj[key];
    else {
      if (Array.isArray(schema[key]) && schema[key].length > 0) {
        obj[key].forEach((innerObj: any, i: number) => {
          innerObj = objParser(innerObj, schema[key][i]);
        });
      } else if (typeof schema[key] === "object") {
        if (schema[key].parser) {
          obj[key] = schema[key].parser(obj[key]);
          delete schema[key].parser;
        }
        if (Object.keys(schema[key]).length > 0) {
          obj[key] = objParser(obj[key], schema[key]);
        }
      }
    }
  });
  return obj;
};
